// extracted by mini-css-extract-plugin
module.exports = {"w1mecebe":"w1mecebe","bj09a15":"bj09a15"};